import NotSupportedBrowserPage from "./not-supported-browser-page";

export default NotSupportedBrowserPage;
